import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type MaterialsDto = ClientInferResponseBody<typeof contract.materials.findAll>;

export const fetchMaterials = async (): Promise<MaterialsDto | null> => {
  const response = await api.materials.findAll.query();

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
